var _g, _rect, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCenter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_79084_89731)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 48,
    height: 48,
    rx: 8,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_79084_89731",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 11,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.6003,
    y: 11.5996,
    width: 28.8,
    height: 28.8,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_79084_89731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1003 38.2398V36.1629C24.6003 35.9059 22.4957 34.9228 20.7865 33.2136C19.0773 31.5044 18.0942 29.3998 17.8372 26.8998H15.7603V25.0998H17.8372C18.0942 22.5998 19.0773 20.4952 20.7865 18.786C22.4957 17.0768 24.6003 16.0937 27.1003 15.8367V13.7598H28.9003V15.8367C31.4003 16.0937 33.5049 17.0768 35.2141 18.786C36.9233 20.4952 37.9064 22.5998 38.1634 25.0998H40.2403V26.8998H38.1634C37.9064 29.3998 36.9233 31.5044 35.2141 33.2136C33.5049 34.9228 31.4003 35.9059 28.9003 36.1629V38.2398H27.1003ZM28.0003 34.3998C30.3203 34.3998 32.3003 33.5798 33.9403 31.9398C35.5803 30.2998 36.4003 28.3198 36.4003 25.9998C36.4003 23.6798 35.5803 21.6998 33.9403 20.0598C32.3003 18.4198 30.3203 17.5998 28.0003 17.5998C25.6803 17.5998 23.7003 18.4198 22.0603 20.0598C20.4203 21.6998 19.6003 23.6798 19.6003 25.9998C19.6003 28.3198 20.4203 30.2998 22.0603 31.9398C23.7003 33.5798 25.6803 34.3998 28.0003 34.3998ZM28.0003 30.1998C26.8453 30.1998 25.8566 29.7885 25.0342 28.9659C24.2116 28.1435 23.8003 27.1548 23.8003 25.9998C23.8003 24.8448 24.2116 23.8561 25.0342 23.0337C25.8566 22.2111 26.8453 21.7998 28.0003 21.7998C29.1553 21.7998 30.144 22.2111 30.9664 23.0337C31.789 23.8561 32.2003 24.8448 32.2003 25.9998C32.2003 27.1548 31.789 28.1435 30.9664 28.9659C30.144 29.7885 29.1553 30.1998 28.0003 30.1998ZM28.0003 28.3998C28.6603 28.3998 29.2253 28.1648 29.6953 27.6948C30.1653 27.2248 30.4003 26.6598 30.4003 25.9998C30.4003 25.3398 30.1653 24.7748 29.6953 24.3048C29.2253 23.8348 28.6603 23.5998 28.0003 23.5998C27.3403 23.5998 26.7753 23.8348 26.3053 24.3048C25.8353 24.7748 25.6003 25.3398 25.6003 25.9998C25.6003 26.6598 25.8353 27.2248 26.3053 27.6948C26.7753 28.1648 27.3403 28.3998 28.0003 28.3998Z",
    fill: "#1C1B1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_79084_89731",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_79084_89731"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_79084_89731",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenter);
export default __webpack_public_path__ + "static/media/center.66fdb03dc697aa6a2f559ab9b2fa29fd.svg";
export { ForwardRef as ReactComponent };